import create from "zustand";

interface ModalState {
  id: string | null;
  classe: string | null;
  isOpen: boolean;
  isEditing: boolean;
  isViewingJobs: boolean;
  isDeleting: boolean;
  isSyncingJobs: boolean;
  setId: (args: string | null) => void;
  setClasse: (args: string) => void;
  setIsOpen: (args: boolean) => void;
  setIsEditing: (args: boolean) => void;
  setIsDeleting: (args: boolean) => void;
  setIsViewingJobs: (args: boolean) => void;
  setIsSyncingJobs: (args: boolean) => void;
}

const useModal = create<ModalState>((set) => ({
  id: null,
  classe: null,
  isOpen: false,
  isEditing: false,
  isDeleting: false,
  isSyncingJobs: false,
  isViewingJobs: false,
  setId: (id) => {
    set((state) => ({ id }));
  },
  setClasse: (classe) => {
    set((state) => ({ classe }));
  },
  setIsOpen: (isOpen) => {
    set((state) => ({ isOpen }));
  },
  setIsEditing: (isEditing) => {
    set((state) => ({ isEditing }));
  },
  setIsDeleting: (isDeleting) => {
    set((state) => ({ isDeleting }));
  },
  setIsViewingJobs: (isViewingJobs) => {
    set((state) => ({ isViewingJobs }));
  },
  setIsSyncingJobs: (isSyncingJobs) => {
    set((state) => ({ isSyncingJobs }));
  },
}));

export default useModal;
